import axios from "axios";
import download from "downloadjs";
import types from "./action-types";
import { showError, showSuccess } from "../../app/toastify";

export const downloadSdReport = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.get("/api/support-desk/tickets/report", {
        params,
        responseType: "blob",
      });
      download(new Blob([data]), "support-desk-report.xlsx", ".xlsx");
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const getSdTickets = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.get("/api/support-desk/tickets", { params });
      dispatch({ type: types.SET_SD_TICKETS, data });
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const getSdTicket = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.get(`/api/support-desk/tickets/${id}`);
      dispatch({ type: types.SET_SD_TICKET, data });
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const sdUpdateStatus = (id, newStatus, note, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.post(`/api/support-desk/tickets/${id}/status`, { newStatus, note });
      dispatch({ type: types.UPDATE_SD_TICKET, data });
      dispatch({ type: types.SET_SD_TICKET, data: null });
      if (onSuccess) onSuccess(data);
      showSuccess("Ticket status updated.");
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const sdRouteToDistrict = (id, officerName, note, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.post(`/api/support-desk/tickets/${id}/route`, { officerName, note });
      dispatch({ type: types.UPDATE_SD_TICKET, data });
      dispatch({ type: types.SET_SD_TICKET, data: null });
      if (onSuccess) onSuccess(data);
      showSuccess("Ticket routed to district.");
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const sdResolve = (id, payload, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      // payload may be a plain note string (legacy) or a structured object.
      const body = typeof payload === "string" ? { note: payload } : payload;
      const { data } = await axios.post(`/api/support-desk/tickets/${id}/resolve`, body);
      dispatch({ type: types.UPDATE_SD_TICKET, data });
      dispatch({ type: types.SET_SD_TICKET, data: null });
      if (onSuccess) onSuccess(data);
      showSuccess("Ticket resolved.");
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};

export const sdStaffComment = (id, body, isInternal, files, onSuccess) => {
  return async (dispatch) => {
    try {
      const form = new FormData();
      form.append("body", body || "");
      form.append("isInternal", isInternal ? "true" : "false");
      (files || []).forEach((f) => form.append("attachments", f));
      const { data } = await axios.post(`/api/support-desk/tickets/${id}/staff-comment`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      dispatch({ type: types.ADD_SD_COMMENT, data });
      if (onSuccess) onSuccess(data);
    } catch (error) {
      showError(error);
    }
  };
};

export const sdReopenStaff = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_SD_LOADING, data: true });
      const { data } = await axios.post(`/api/support-desk/tickets/${id}/reopen-staff`);
      dispatch({ type: types.UPDATE_SD_TICKET, data });
      dispatch({ type: types.SET_SD_TICKET, data: null });
      if (onSuccess) onSuccess(data);
      showSuccess("Ticket reopened.");
    } catch (error) {
      showError(error);
    } finally {
      dispatch({ type: types.SET_SD_LOADING, data: false });
    }
  };
};
